export const environment = {
  tinymceApiKey: 'ybetk7adiq44b6roa827nxg5yqw8kahv6fjymooiejq5meo6',
  production: true,
  withCredentials: false,
  guestEndpoint: '/guest',
  mainEndpoint: '/main',
  systemAPI: 'https://api-use1.biggerpicture.ai/adminAPI',
  venditioAPI: 'https://api-use1.biggerpicture.ai/siteAPI',
  offlineAPI: 'https://pub-api-use1.biggerpicture.ai',
  bucketUrl: 'https://assets.biggerpicture.ai/assets',
  posURL: 'https://pos-use1.biggerpicture.ai',
  ecomURL: 'https://ecom-use1.biggerpicture.ai/master-event?saleChannelCode=web',
  isTestMode: false
};
